import type { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="empty" role="region" aria-label="Belum ada konten">
      <div className="empty__art" aria-hidden="true">
        <svg viewBox="0 0 240 180" width="240" height="180" focusable="false">
          <defs>
            <linearGradient id="emptyG1" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="var(--color-accent)" stopOpacity="0.18" />
              <stop offset="1" stopColor="var(--color-accent)" stopOpacity="0" />
            </linearGradient>
            <linearGradient id="emptyG2" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="var(--color-primary)" stopOpacity="0.14" />
              <stop offset="1" stopColor="var(--color-primary)" stopOpacity="0" />
            </linearGradient>
          </defs>
          {/* Back card (tilted) */}
          <g transform="translate(28 38) rotate(-6 70 60)">
            <rect
              x="0"
              y="0"
              width="160"
              height="110"
              rx="14"
              fill="url(#emptyG2)"
              stroke="currentColor"
              strokeOpacity="0.18"
              strokeWidth="1.5"
            />
            <rect x="20" y="22" width="80" height="6" rx="3" fill="currentColor" opacity="0.12" />
            <rect x="20" y="36" width="120" height="6" rx="3" fill="currentColor" opacity="0.08" />
            <rect x="20" y="50" width="100" height="6" rx="3" fill="currentColor" opacity="0.08" />
          </g>
          {/* Front card */}
          <g transform="translate(54 22)">
            <rect
              x="0"
              y="0"
              width="160"
              height="130"
              rx="16"
              fill="var(--color-bg-elevated)"
              stroke="currentColor"
              strokeOpacity="0.22"
              strokeWidth="1.5"
              filter="drop-shadow(0 14px 28px rgba(15, 23, 42, 0.08))"
            />
            {/* Eyebrow accent dot */}
            <circle cx="22" cy="24" r="4" fill="var(--color-accent)" />
            <rect x="34" y="20" width="58" height="6" rx="3" fill="currentColor" opacity="0.5" />
            {/* Big title bar */}
            <rect x="22" y="44" width="116" height="11" rx="5" fill="currentColor" opacity="0.85" />
            {/* Lines */}
            <rect x="22" y="68" width="90" height="6" rx="3" fill="currentColor" opacity="0.16" />
            <rect x="22" y="80" width="116" height="6" rx="3" fill="currentColor" opacity="0.12" />
            <rect x="22" y="92" width="74" height="6" rx="3" fill="currentColor" opacity="0.12" />
            {/* CTA pill */}
            <rect
              x="22"
              y="108"
              width="60"
              height="14"
              rx="7"
              fill="url(#emptyG1)"
              stroke="var(--color-accent)"
              strokeOpacity="0.45"
            />
          </g>
          {/* Decorative spark */}
          <g
            transform="translate(196 18)"
            stroke="var(--color-accent)"
            strokeWidth="1.8"
            strokeLinecap="round"
            opacity="0.9"
          >
            <path d="M0 10 L0 -10 M-10 0 L10 0" />
          </g>
        </svg>
      </div>
      <h2 className="empty__title">{title}</h2>
      {description ? <p className="empty__desc">{description}</p> : null}
      {action ? <div className="empty__action">{action}</div> : null}
    </div>
  );
}
